import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { ChannelProfileLookupsDao, ChannelProfileSearchRowDao } from '@/interfaces/channel-profile/ChannelProfile.dao'
import { ChannelProfileDetailDao } from '@/interfaces/channel-profile/ChannelProfileDetail.dao'
import {
    ChannelProfileMappingImportResult,
    ChannelProfileMappingRow,
    ChannelProfileMappingValidatedRow,
} from '@/interfaces/channel-profile/ChannelProfileMapping.dto'
import { ChannelProfileStockDao } from '@/interfaces/channel-profile/ChannelProfileStock.dao'
import { ChannelProfileWriteDto } from '@/interfaces/channel-profile/ChannelProfileWrite.dto'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class ChannelProfilesService extends ApiService {
    async searchChannelProfiles(
        params?: IRequestParameters,
    ): Promise<[ChannelProfileSearchRowDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ChannelProfileSearchRowDao[], PageNumberPagination] | null>(
            'GET',
            '/channel-profiles/search',
            params,
            undefined,
            undefined,
            'searchChannelProfiles',
        ).catch(() => null)
    }

    async getChannelProfileLookups(): Promise<ChannelProfileLookupsDao | null> {
        return this.request<undefined, ChannelProfileLookupsDao>(
            'GET',
            '/channel-profiles/lookups',
            undefined,
            undefined,
            undefined,
            'getChannelProfileLookups',
        ).catch(() => null)
    }

    async getChannelProfile(id: number): Promise<ChannelProfileDetailDao | null> {
        return this.request<undefined, ChannelProfileDetailDao>(
            'GET',
            `/channel-profiles/${id}`,
            undefined,
            undefined,
            undefined,
            'getChannelProfile',
        ).catch(() => null)
    }

    async getChannelProfileStock(id: number): Promise<ChannelProfileStockDao | null> {
        return this.request<undefined, ChannelProfileStockDao>(
            'GET',
            `/channel-profiles/${id}/stock`,
            undefined,
            undefined,
            undefined,
            'getChannelProfileStock',
        ).catch(() => null)
    }

    async createChannelProfile(dto: ChannelProfileWriteDto): Promise<ChannelProfileDetailDao | null> {
        return this.request<ChannelProfileWriteDto, ChannelProfileDetailDao>(
            'POST',
            '/channel-profiles',
            undefined,
            dto,
            undefined,
            'createChannelProfile',
        ).catch(() => null)
    }

    async updateChannelProfile(id: number, dto: ChannelProfileWriteDto): Promise<ChannelProfileDetailDao | null> {
        return this.request<ChannelProfileWriteDto, ChannelProfileDetailDao>(
            'PUT',
            `/channel-profiles/${id}`,
            undefined,
            dto,
            undefined,
            'updateChannelProfile',
        ).catch(() => null)
    }

    async deleteChannelProfile(id: number): Promise<boolean | null> {
        return this.request<undefined, void>(
            'DELETE',
            `/channel-profiles/${id}`,
            undefined,
            undefined,
            undefined,
            'deleteChannelProfile',
        )
            .then(() => true)
            .catch(() => null)
    }

    async deleteChannelProfileMaterials(id: number, materialIds: number[]): Promise<ChannelProfileDetailDao | null> {
        return this.request<{ MaterialIds: number[] }, ChannelProfileDetailDao>(
            'DELETE',
            `/channel-profiles/${id}/materials`,
            undefined,
            { MaterialIds: materialIds },
            undefined,
            'deleteChannelProfileMaterials',
        ).catch(() => null)
    }

    async validateChannelProfileMappings(
        rows: ChannelProfileMappingRow[],
    ): Promise<ChannelProfileMappingValidatedRow[] | null> {
        return this.request<{ rows: ChannelProfileMappingRow[] }, ChannelProfileMappingValidatedRow[]>(
            'POST',
            '/channel-profiles/validate-mappings',
            undefined,
            { rows },
            undefined,
            'validateChannelProfileMappings',
        ).catch(() => null)
    }

    async importChannelProfileMappings(
        rows: ChannelProfileMappingRow[],
    ): Promise<ChannelProfileMappingImportResult | null> {
        return this.request<{ rows: ChannelProfileMappingRow[] }, ChannelProfileMappingImportResult>(
            'POST',
            '/channel-profiles/import-mappings',
            undefined,
            { rows },
            undefined,
            'importChannelProfileMappings',
        ).catch(() => null)
    }
}
